var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServerpod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08132 13.6806C7.21484 9.425 9.42598 5.53942 12.4979 2.40485L12.8049 2.09165C13.0355 1.85633 13.4131 1.85859 13.6409 2.09667L14.1071 2.58385C17.0813 5.69177 19.2325 9.50369 20.3629 13.669C20.4596 14.0253 20.1936 14.3767 19.8272 14.3767H6.61085C6.25021 14.3767 5.98779 14.0317 6.08132 13.6806Z",
    fill: "url(#paint0_linear_34_14318)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91406 22.3646C5.57458 22.3646 5.27359 22.5643 5.29395 22.9819C5.36762 24.4947 5.56571 25.7594 5.73743 27.0173L5.77384 27.1718C5.82984 27.4902 6.11446 27.6899 6.42407 27.6899H20.0058C20.2904 27.6899 20.5393 27.4963 20.6116 27.2188L20.6563 27.047C20.8851 25.9591 21.0171 24.8275 21.1563 22.9392C21.184 22.5643 20.8951 22.3646 20.5792 22.3646H5.91406ZM10.0559 24.0953C9.98295 24.0953 9.92382 24.1549 9.92382 24.2284V25.826C9.92382 25.8995 9.98295 25.9591 10.0559 25.9591H16.3949C16.4679 25.9591 16.527 25.8995 16.527 25.826V24.2284C16.527 24.1549 16.4679 24.0953 16.3949 24.0953H10.0559Z",
    fill: "url(#paint1_linear_34_14318)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60318 29.0212C8.96787 29.0212 9.2635 29.3192 9.2635 29.6868V31.4081C9.2635 31.7612 9.19748 32.0832 8.8767 32.3495L5.50439 34.8172L4.57056 33.8758L7.94287 31.4081V29.6868C7.94287 29.3192 8.2385 29.0212 8.60318 29.0212Z",
    fill: "#3180FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.32071 37.0091C4.05008 37.0091 4.64135 36.4131 4.64135 35.6778C4.64135 34.9425 4.05008 34.3465 3.32071 34.3465C2.59135 34.3465 2.00008 34.9425 2.00008 35.6778C2.00008 36.4131 2.59135 37.0091 3.32071 37.0091ZM3.32071 38.3404C4.77944 38.3404 5.96198 37.1483 5.96198 35.6778C5.96198 34.2072 4.77944 33.0151 3.32071 33.0151C1.86198 33.0151 0.679443 34.2072 0.679443 35.6778C0.679443 37.1483 1.86198 38.3404 3.32071 38.3404Z",
    fill: "#3180FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8478 29.0212C17.4831 29.0212 17.1874 29.3192 17.1874 29.6868V31.4081C17.1874 31.7612 17.1874 32.0832 17.5743 32.3495L21.0786 34.8172L22.0125 33.8758L18.5081 31.4081V29.6868C18.5081 29.3192 18.2124 29.0212 17.8478 29.0212Z",
    fill: "#3180FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1302 37.0091C22.4009 37.0091 21.8096 36.4131 21.8096 35.6778C21.8096 34.9425 22.4009 34.3465 23.1302 34.3465C23.8596 34.3465 24.4509 34.9425 24.4509 35.6778C24.4509 36.4131 23.8596 37.0091 23.1302 37.0091ZM23.1302 38.3404C21.6715 38.3404 20.489 37.1483 20.489 35.6778C20.489 34.2072 21.6715 33.0151 23.1302 33.0151C24.5889 33.0151 25.7715 34.2072 25.7715 35.6778C25.7715 37.1483 24.5889 38.3404 23.1302 38.3404Z",
    fill: "#3180FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2255 29.0212C13.5902 29.0212 13.8858 29.3192 13.8858 29.6868L13.8858 33.6808L12.5652 33.6808L12.5652 29.6868C12.5652 29.3192 12.8608 29.0212 13.2255 29.0212Z",
    fill: "#3180FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2255 37.0091C13.9549 37.0091 14.5461 36.4131 14.5461 35.6778C14.5461 34.9425 13.9549 34.3465 13.2255 34.3465C12.4961 34.3465 11.9049 34.9425 11.9049 35.6778C11.9049 36.4131 12.4961 37.0091 13.2255 37.0091ZM13.2255 38.3404C14.6842 38.3404 15.8668 37.1483 15.8668 35.6778C15.8668 34.2072 14.6842 33.0151 13.2255 33.0151C11.7668 33.0151 10.5842 34.2072 10.5842 35.6778C10.5842 37.1483 11.7668 38.3404 13.2255 38.3404Z",
    fill: "#3180FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14416 15.7079C5.88052 15.7079 5.63178 15.8411 5.57946 16.1418C5.28273 17.8649 5.25871 19.3025 5.28845 20.5022C5.29578 20.7976 5.53543 21.0332 5.82854 21.0332H20.6223C20.9154 21.0332 21.1551 20.7976 21.1624 20.5022C21.1624 19.236 21.2473 18.1312 20.8714 16.1418C20.8015 15.8855 20.5703 15.7079 20.3067 15.7079H6.14416ZM10.0559 17.4387C9.98297 17.4387 9.92384 17.4983 9.92384 17.5718V19.1694C9.92384 19.2429 9.98297 19.3025 10.0559 19.3025H16.395C16.4679 19.3025 16.527 19.2429 16.527 19.1694V17.5718C16.527 17.4983 16.4679 17.4387 16.395 17.4387H10.0559Z",
    fill: "url(#paint2_linear_34_14318)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_14318",
    x1: 13.2254,
    y1: 2.39474,
    x2: 13.2254,
    y2: 14.3767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36E7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CC5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34_14318",
    x1: 17.1709,
    y1: 27.7156,
    x2: 17.1709,
    y2: 22.3352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3180FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34_14318",
    x1: 13.2247,
    y1: 15.7079,
    x2: 13.2247,
    y2: 21.0332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BC6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EB0FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerpod);
export default __webpack_public_path__ + "static/media/serverpod.eb63cd7814d02e85af5b1e04562399c9.svg";
export { ForwardRef as ReactComponent };